import { ErrorTemplateBuilder } from "./error-template-builder";
import store from "../root/store/store";
import { EntitySyncManager } from "./entity-sync-manager";
import contactService from "../common/services/contact-service";

export class IndexDBSyncManager {
  private static applicationTicks: any;
  constructor(_applicationTicks: any = null) {
    IndexDBSyncManager.applicationTicks = _applicationTicks;
  }

  static async clearIndexedDBAndReloadData(reloadData: boolean = true) {
    try {
      if (reloadData) {
        await EntitySyncManager.fillContactTags();

        await contactService.setContactTagPermissions();

        await EntitySyncManager.fillLoggedInClient();

        await Promise.all([
          EntitySyncManager.fillFormList(),
          EntitySyncManager.fillContacts(),
          EntitySyncManager.fillEmailConfigurationInfo(),
          EntitySyncManager.fillTechnicianGroup(),
          EntitySyncManager.fillProjectType(),
          EntitySyncManager.getEmailConfigurations(),
          EntitySyncManager.fillTickets(),
          EntitySyncManager.fillProjects(),
          EntitySyncManager.fillTechnicians(),
          EntitySyncManager.fillClientLocations(),
          EntitySyncManager.fillCustomStatus(),
          EntitySyncManager.fillTags(),
        ]);

        await contactService.setIsBillingContact();

        await EntitySyncManager.fillMSPTicketSettings();
        await store.dispatch("getCustomDomainConfiguration");
      }
    } catch (e) {
      throw new Error(
        ErrorTemplateBuilder.getCatchText(
          "IndexDBSyncManager.clearIndexedDBAndReloadData",
          e,
        ),
      );
    }
  }
}
